<button
  type="button"
  class="lang-toggle"
  (click)="toggle()"
  [attr.aria-label]="currentLang === 'ar' ? 'Switch to English' : 'التبديل إلى العربية'"
>
  <img
    *ngIf="currentLang === 'en'"
    src="assets/images/auth/flag-sa.svg"
    alt=""
    class="lang-toggle__flag"
  />
  <span>{{ currentLang === 'ar' ? 'English' : 'العربية' }}</span>
</button>
